import { type IRecurringAvailability } from "@/interfaces/api/recurring-availability.interface.ts"
import { BaseRepository } from "@/repositories/base-repository"

export class RecurringAvailabilityRepository extends BaseRepository<IRecurringAvailability> {
  resourcePath = "core/recurring-availabilities"
}
